import { generatePath } from "react-router-dom";
import type { Path } from "@/router";

import { MEMBER_ELECTIONS_PENDING_PATH } from "../constants";

export const MEMBER_ELECTIONS_PATH = MEMBER_ELECTIONS_PENDING_PATH;

export function buildMemberElectionPersonPath(
  pgaId: string | null | undefined,
  searchParamsUrl = "",
  isCompactLayout = false,
  returnToPath: Path = MEMBER_ELECTIONS_PENDING_PATH
): Path | null {
  if (!pgaId) {
    return null;
  }

  const returnToQuery = searchParamsUrl ? `&${searchParamsUrl}` : "";

  if (isCompactLayout) {
    return `${generatePath(`/people/:pgaId`, { pgaId })}?return_to=${returnToPath}${returnToQuery}` as Path;
  }

  const personOverviewPath = `/people/:pgaId/person/overview`;
  return `${generatePath(personOverviewPath, { pgaId })}?return_to=${returnToPath}${returnToQuery}` as Path;
}
